"use client";

import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["children"],
  _excluded2 = ["value"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import Context, { prepareContext } from './Context';
import { prepareFormElementContext } from './helpers/filterValidProps';
export default function Provider(localProps) {
  const {
      children
    } = localProps,
    props = _objectWithoutProperties(localProps, _excluded);
  const context = React.useContext(Context);
  const [localContext, setLocalContext] = React.useState(null);
  let value = mergeContext(context, _objectSpread(_objectSpread({}, localContext), props));
  if (context) {
    value = prepareContext(value);
    context.updateTranslation(value.locale, value.translation);
  }
  value.update = updateAll;
  value.setLocale = setAllLocale;
  value.updateCurrent = updateCurrent;
  value.setCurrentLocale = setCurrentLocale;
  return React.createElement(Context.Provider, {
    value: value
  }, children);
  function updateCurrent(props) {
    setLocalContext({
      __context__: props
    });
  }
  function setCurrentLocale(locale) {
    setLocalContext({
      __context__: {
        locale
      }
    });
  }
  function setAllLocale(locale) {
    updateAll({
      locale
    });
  }
  function updateAll(props) {
    if (typeof context.update === 'function') {
      context.update(props);
    }
    setLocalContext({
      __context__: props
    });
  }
}
function mergeContext(context, props) {
  const {
      value
    } = props,
    rest = _objectWithoutProperties(props, _excluded2);
  const merge = _objectSpread(_objectSpread({}, value), rest);
  const mergedContext = _objectSpread(_objectSpread({}, context), merge);
  if (context !== null && context !== void 0 && context.formElement && merge.formElement) {
    mergedContext.formElement = _objectSpread(_objectSpread({}, context.formElement), merge.formElement);
    mergedContext.formElement = prepareFormElementContext(mergedContext.formElement);
  }
  if (context !== null && context !== void 0 && context.FormRow && merge.FormRow) {
    mergedContext.FormRow = _objectSpread(_objectSpread({}, context.FormRow), merge.FormRow);
    mergedContext.FormRow = prepareFormElementContext(mergedContext.FormRow);
  }
  return mergedContext;
}
//# sourceMappingURL=Provider.js.map